import React, {useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import { useDispatch, useSelector } from 'react-redux';
import { hideModal, setShowModal } from '../redux/features/oxygen/customModalSlice';
import useCustomAlert from '../components/Alert2';
import { getFBNDeviceByTenure, setOtpLoading, updateFBNDevicesPagination, updateFBNDevicesSearch, getFBNFetchMoreDevices } from '../redux/features/oxygen/oxygenRetailSlice';
import { updatePrecustomer } from '../redux/features/precustomers/PrecustomerSlice';
import { fbnSubmitCustomerBundle, updateCustomerOnboardingStat } from '../services/PrequalificationService';
import FBNDeviceCard from './FBNDeviceCard';
import Pagination from './Pagination';

const FBNDeviceBundles = () => {
    const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [selectedTenor, setSelectedTenor] = useState("");
    const [whichCall, setWhichCall] = useState(0);
    const precustomer =  useSelector((state) => state?.precustomer?.precustomerData.precustomer);
    const financierID = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
    const userId = useSelector((state) => state?.user?.user?.id);
    const fbnDeviceByTenure = useSelector((state) => state?.oxygenRetail);
    const deviceBundles = fbnDeviceByTenure?.fbnDeviceByTenure?.data ;

    useEffect(() => {
        if (!selectedTenor) return;

        const fetchDevices = async () => {
        setLoading(true);
        let response;
        const payload = {
            preCustomerId: Number(precustomer?.precustomerId),
            tenure: Number(selectedTenor),
            amount: 0,
            storeId: 0,
            financierId: String(financierID),
        };

        if (whichCall === 0) {
            response =  await dispatch(getFBNDeviceByTenure(payload)).unwrap();
        }else if (whichCall === 1) {
            response = await dispatch(getFBNFetchMoreDevices(payload)).unwrap()
        }
        console.log("FBN Device by Tenure Response:", response);

        if (response?.status) {
            setErrorMessage("");
        } else {
            customAlert.showToast("error", response?.message || "Failed to fetch device..!");
            setErrorMessage(response?.message || "Failed to fetch device..!");
        }

        setLoading(false);
        };

        fetchDevices();
  }, [selectedTenor, fbnDeviceByTenure?.devicesParams, whichCall]);


    const handleSearchDevice  = async() => {
        const payload = searchValue;
        dispatch(updateFBNDevicesSearch(payload));
    }

     const handlePagination = (page) => {
        dispatch(updateFBNDevicesPagination(page));
    };

    const paginationData = {
        totalPages: deviceBundles?.meta?.totalPages,
        currentPage: deviceBundles?.meta?.currentPage,
        handlePagination
    }

    const tenure =  whichCall === 0 ? selectedTenor : whichCall === 1 ? deviceBundles?.tenure : deviceBundles?.tenure;
    console.log("tenure:", tenure);
    console.log("whichCall:", whichCall);

    const handleSelectBundle = (device_type_id) => {
        dispatch(setShowModal({
            status:true,
            title:"Select your Bundle",
            type:"fbnBundleModal",
            showCloseButton:false,
            data:{device_type_id, tenure:tenure, onClick:handleSubmitBundle},
        }));
    }

    const handleSubmitBundle = async(bundle, device_type_id) => {
        dispatch(setOtpLoading(true));
        console.log("bundle modal:", bundle, device_type_id);
        let res;
        const payload= {
            deviceOptionId: String(bundle?.id),
            bundleDeviceTypeId:  String(device_type_id) || String(precustomer?.bundled_device_type_id),
            down_payt: String(bundle?.down_payt),
            equityContribution: String(bundle?.equity_contribution) || "0",
            preCustomerId: Number(deviceBundles?.preCustomer_id) || Number(precustomer?.precustomerId),
            repId: Number(userId),
            isSelfOnboard: false
        }

        res = await fbnSubmitCustomerBundle(payload);
        console.log("submit-bundle res:", res);
        
        if(res?.status === true) {
            dispatch(setOtpLoading(false));
            // Make api call to update the onboarding status 
            await updateCustomerOnboardingStat(
                precustomer?.msisdn,
                "BUNDLE_SELECTED"
            );
            customAlert.showToast("success", `${res?.message}` || `Bundle submitted successfully`);
            dispatch(hideModal());
                // go to liveness check
                dispatch(updatePrecustomer({
                    precustomer: {
                        ...precustomer, 
                    },
                    onboarding_status: "liveness-check",
                }));
                navigate("/liveness-check"); 
        }else{
            dispatch(setOtpLoading(false));
            customAlert.showToast("error", `${res?.message}` || "Failed to submit bundle..!");
        }
    }

  return (
    <PageWrapper>
        <PageTitle title={`Device Bundle`} />
        <div className="d-flex justify-content-end flex-row gap-3 mt-6 mb-8">
            <div className="d-flex flex-column gap-2">
                <h1 className="page-title">Tenure Selection</h1>
                <select 
                    className="form-select customInputWidth"
                    value={selectedTenor}
                    onChange={(e) => {
                        setSelectedTenor(e.target.value);
                        setWhichCall(0);
                    }}
                    style={{
                        width: "200px",
                        fontWeight: 600,
                        cursor: "pointer"
                    }}
                >
                    <option value="">Select Tenor</option>
                    <option value="3">3 Months</option>
                    <option value="6">6 Months</option>
                    <option value="9">9 Months</option>
                    <option value="12">12 Months</option>
                </select>
            </div>
        </div>

        {loading ? (
            <p className='text-center'>Fetching devices...</p>
        ):errorMessage ? (
            <div className="alert alert-danger" role="alert">
            {errorMessage}
        </div>
        ):(
            <>
            {
                deviceBundles?.records?.length > 0 && (
                    <>
                        <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mt-6 mb-6">
                            <button disabled={whichCall === 1} className="btn btn-primary w-auto align-self-end" onClick={() => setWhichCall(1)}>Choose more Devices</button>
                            <div class="input-group customInputWidth ">
                            <input 
                                type="search"
                                value={searchValue} 
                                className="form-control bg-light"
                                placeholder="Search devices"
                                onChange={(e)=> setSearchValue(e.target.value)}
                            />
                            <span class="input-group-text" id="button-addon1" style={{borderRadius: "0 5px 5px 0", boxShadow: "0 4px 8px rgba(128, 128, 128, 0.4)", cursor: "pointer", fontWeight:"600"}}
                                onClick={handleSearchDevice}
                            >Search</span>
                        </div>
                        </div>
                            <div className="card shadow rounded-4 py-4 px-5">
                                <h5 className="fw-bold my-5">Eligible Amount: #{deviceBundles?.eligibleAmount.toLocaleString()}</h5>
                            </div>
                        {Array.isArray(deviceBundles?.records) && deviceBundles?.records?.map((deviceBundle, index) => (
                            <FBNDeviceCard 
                                key={index} 
                                data={deviceBundle} 
                                onClick={handleSelectBundle} 
                            /> 
                        ))}
                        <Pagination {...paginationData} />
                    </>
                )       
            }
            </>
        )}
        

    </PageWrapper>
  )
}

export default FBNDeviceBundles;